import React from 'react';
import { UserAuth } from '../../context/AuthContext';
import ro from '../../locales/ro.json';
import './Navigation.css';

function Navbar() {
    const [navState, setNavState] = React.useState(false);
    const [expandedCategory, setExpandedCategory] = React.useState(null);
    const { logOut, user, loading } = UserAuth();

    const handleSignOut = async () => {
        try {
            await logOut();
            window.location.assign("/login");
        } catch (error) {
            console.log(error);
        }
    };

    const activateNavbar = () => {
        setNavState(!navState);
        setExpandedCategory(null);
    };

    const handleAction = (action) => {
        if (action === "logout") handleSignOut();
        else window.location.assign(action);
    };

    const isVisible = (item) => {
        if (!item.inProduction && !user.isAdmin) return false;
        
        if (item.uiKey) {
            if (user.isAdmin) return true;
            if (!user.allowedUI || !user.allowedUI.includes(item.uiKey)) return false;
        } else if (item.isAdmin && !user.isAdmin) {
            return false;
        }
        
        return true;
    };

    const handleCategoryClick = (category, index) => {
        const visibleItems = (category.items || []).filter(isVisible);
        if (visibleItems.length === 0) {
            handleAction(category.action);
            return;
        }
        if (expandedCategory !== index) {
            setExpandedCategory(index);
        } else {
            handleAction(category.action);
        }
    };

    const renderCategory = (category, index) => {
        if (!isVisible(category)) return null;

        const visibleItems = (category.items || []).filter(isVisible);
        const hasSubItems = visibleItems.length > 0;
        const isExpanded = expandedCategory === index;

        return (
            <div
                key={index}
                className={`nav-entry ${isExpanded ? "expanded" : ""}`}
                onMouseEnter={hasSubItems ? () => setExpandedCategory(index) : undefined}
                onMouseLeave={hasSubItems ? () => setExpandedCategory(null) : undefined}
            >
                {hasSubItems && (
                    <div className="nav-sub-items">
                        {visibleItems.map((item, i) => (
                            <div
                                key={i}
                                className="nav-item-wrapper"
                                onClick={() => handleAction(item.action)}
                            >
                                <img className="nav-item-icon" src={item.icon} alt="" />
                            </div>
                        ))}
                    </div>
                )}
                <div
                    className="nav-item-wrapper"
                    onClick={() => hasSubItems ? handleCategoryClick(category, index) : handleAction(category.action)}
                >
                    <img className="nav-item-icon" src={category.icon} alt="" />
                </div>
            </div>
        );
    };

    return (
        <div>
            {!loading && user ? (
                <div className={"nav-wrapper" + (navState ? " nav-wrapper-open" : "")}>
                    <div className={navState ? "nav-photo-wrapper" : ""}>
                        <img
                            className={"nav-user-photo" + (navState ? " nav-user-open" : "")}
                            src={user.profile?.picture_url || user.photoURL}
                            onClick={activateNavbar}
                            referrerPolicy="no-referrer"
                            alt="User"
                        />
                        {navState ? (
                            <div className="nav-blur-background" onClick={() => { setNavState(false); setExpandedCategory(null); }}></div>
                        ) : null}
                    </div>

                    <div style={{ display: navState ? null : "none" }}>
                        {ro.navbar.categories.map((cat, index) => renderCategory(cat, index))}
                    </div>
                </div>
            ) : null}
        </div>
    );
}

export default Navbar;